import { CircularProgress } from '@mui/material';
import _ from 'lodash';
import { InboxViewModel } from './useInbox.viewModel';
import { MessagingSidebar } from './MessagingSidebar';
import {
  useCreateChatClient,
  Chat,
  ChatView,
  Channel,
  ChannelHeader,
  MessageInput,
  MessageList,
  Thread,
  Window,
} from 'stream-chat-react';
import { chatFormatDate } from './helpers';
import 'stream-chat-react/dist/css/v2/index.css';
import './chat.css';
import { useChatViewModel } from './useChat.viewModel';

export const InboxChat = (p: InboxViewModel) => {
  const chatClient = useCreateChatClient({
    apiKey: import.meta.env.VITE_STREAM_CHAT_ID,
    userData: { id: p.userId },
    tokenOrProvider: p.streamToken,
  });

  if (!chatClient) {
    return (
      <div className="w-full h-full justify-center items-center">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="p-2.5 bg-white rounded-[10px] w-full h-full">
      <Chat client={chatClient}>
        <ChatContent userId={p.userId} />
      </Chat>
    </div>
  );
};

const ChatContent = ({ userId }: { userId: string }) => {
  const { channelListOptions } = useChatViewModel({ userId });
  return (
    <ChatView>
      <ChatView.Channels>
        <MessagingSidebar channelListOptions={channelListOptions} />
        <Channel>
          <Window>
            <ChannelHeader />
            <MessageList
              messageActions={['flag', 'mute', 'react']}
              formatDate={chatFormatDate}
            />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </ChatView.Channels>
    </ChatView>
  );
};
